import { NormalizedFeatures } from '@ww-digital/xs-sdk';
import deepmerge from 'deepmerge';

export const combineTestAutoRoutes = (
  vsExpTextIDs: string[],
  normalizedFeatures: NormalizedFeatures,
  updatableWWTests: any,
): any => {
  vsExpTextIDs.forEach((expTextId) => {
    try {
      const attributes =
        normalizedFeatures[expTextId]?.variations?.control?.attributes;
      if (attributes?.autoRoute || attributes?.pageTargeting) {
        updatableWWTests = deepmerge(
          updatableWWTests,
          JSON.parse(
            normalizedFeatures[expTextId]?.variations?.control?.attributes
              ?.autoRoute.value ?? null,
          ),
        );
      }
    } catch (ex) {
      console.warn(ex);
    }
  });
  return updatableWWTests;
};
